module.exports = __webpack_public_path__ + "static/wifiman9-7df009e4678b0ee34bb264a4ebfa4d6d.png";